import { render, staticRenderFns } from "./pgcExport.vue?vue&type=template&id=92e8e848&scoped=true"
import script from "./pgcExport.vue?vue&type=script&lang=js"
export * from "./pgcExport.vue?vue&type=script&lang=js"
import style0 from "./pgcExport.vue?vue&type=style&index=0&id=92e8e848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e8e848",
  null
  
)

export default component.exports